var ResourceState = /* @__PURE__ */ function(ResourceState2) {
  ResourceState2["PENDING"] = "pending";
  ResourceState2["PROCESSING"] = "processing";
  ResourceState2["COMPLETED"] = "completed";
  ResourceState2["FAILED"] = "failed";
  return ResourceState2;
}({});
const parseResourceState = (state) => {
  return Object.values(ResourceState).includes(state) ? state : "failed";
};

export { ResourceState, parseResourceState };
//# sourceMappingURL=api.js.map
